import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-icon" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_6 = { class: "status-icon" }
const _hoisted_7 = { class: "status-content" }
const _hoisted_8 = { class: "status-date" }
const _hoisted_9 = { class: "request-detail-section" }
const _hoisted_10 = { class: "detail-row" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_13 = { class: "employee-chips" }
const _hoisted_14 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_15 = { class: "employee-chips" }
const _hoisted_16 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_17 = { class: "value memo" }
const _hoisted_18 = {
  key: 0,
  class: "admin-response-section"
}
const _hoisted_19 = {
  key: 0,
  class: "admin-memo"
}
const _hoisted_20 = {
  key: 1,
  class: "no-memo"
}
const _hoisted_21 = {
  key: 1,
  class: "cancel-reason-section"
}
const _hoisted_22 = { class: "cancel-memo" }
const _hoisted_23 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_24 = {
  key: 0,
  class: "warning-section center-warning"
}
const _hoisted_25 = { class: "warning-header" }
const _hoisted_26 = { class: "center-form-grid" }
const _hoisted_27 = { class: "phone-input-group" }
const _hoisted_28 = { class: "address-input-group" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "center-form-item full-width" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "warning-section"
}
const _hoisted_33 = { class: "warning-header" }
const _hoisted_34 = { class: "birth-number-edit-list" }
const _hoisted_35 = { class: "emp-info-row" }
const _hoisted_36 = { class: "emp-name" }
const _hoisted_37 = {
  key: 0,
  class: "emp-birth-tag"
}
const _hoisted_38 = { class: "birth-number-input-row" }
const _hoisted_39 = ["onUpdate:modelValue", "onInput"]
const _hoisted_40 = ["onUpdate:modelValue", "onInput"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = {
  key: 0,
  class: "input-preview"
}
const _hoisted_44 = {
  key: 0,
  class: "valid-mark"
}
const _hoisted_45 = {
  key: 1,
  class: "invalid-mark"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "form-section" }
const _hoisted_48 = { class: "form-section" }
const _hoisted_49 = { class: "section-header" }
const _hoisted_50 = { class: "form-label" }
const _hoisted_51 = {
  key: 0,
  class: "selected-count"
}
const _hoisted_52 = { class: "employee-selection-grid" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "emp-avatar new" }
const _hoisted_55 = { class: "emp-info" }
const _hoisted_56 = { class: "emp-name" }
const _hoisted_57 = {
  key: 0,
  class: "emp-birth"
}
const _hoisted_58 = { class: "emp-date" }
const _hoisted_59 = {
  key: 0,
  class: "check-mark"
}
const _hoisted_60 = {
  key: 0,
  class: "no-employee-notice"
}
const _hoisted_61 = { class: "form-section" }
const _hoisted_62 = { class: "section-header" }
const _hoisted_63 = { class: "form-label" }
const _hoisted_64 = {
  key: 0,
  class: "selected-count"
}
const _hoisted_65 = { class: "employee-selection-grid" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "emp-avatar resigned" }
const _hoisted_68 = { class: "emp-info" }
const _hoisted_69 = { class: "emp-name" }
const _hoisted_70 = {
  key: 0,
  class: "emp-birth"
}
const _hoisted_71 = { class: "emp-date" }
const _hoisted_72 = {
  key: 0,
  class: "check-mark"
}
const _hoisted_73 = {
  key: 0,
  class: "no-employee-notice"
}
const _hoisted_74 = { class: "form-section" }
const _hoisted_75 = { class: "modal-footer" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = ["disabled"]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = { class: "dialog-header warning" }
const _hoisted_80 = { class: "dialog-body" }
const _hoisted_81 = { class: "dialog-footer" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]

import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface Employee {
  emp_code: string;
  emp_name: string;
  emp_birth?: string;
  emp_birth_number?: string;
  emp_job?: string;
  emp_in_date?: string;
  emp_out_date?: string;
}

interface WageTaxRequest {
  wtr_idx: number;
  m_sisul_code: string;
  wtr_leb_ym: string;
  wtr_type: string;
  wtr_status: string;
  wtr_new_employees?: string;
  wtr_resigned_employees?: string;
  wtr_request_memo?: string;
  wtr_requested_by?: string;
  wtr_requested_at?: string;
  wtr_cancelled_by?: string;
  wtr_cancelled_at?: string;
  wtr_cancel_reason?: string;
  wtr_result_memo?: string;
  wtr_processed_by?: string;
  wtr_processed_at?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WageTaxReq',
  props: {
    modelValue: { type: Boolean },
    yearMonth: {}
  },
  emits: ["update:modelValue", "request-submitted", "request-cancelled"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

// 상태
const isLoading = ref(false);
const isSubmitting = ref(false);
const isCancelling = ref(false);
const showCancelDialog = ref(false);
const cancelReason = ref('');
const currentRequest = ref<WageTaxRequest | null>(null);
const employees = ref<Employee[]>([]);

// 주민등록번호 인라인 입력 상태
const birthNumberInputs = ref<Record<string, { front: string; back: string }>>({});
const savingEmpCode = ref<string | null>(null);
const isSavingAllBirthNumbers = ref(false);

// 기관 정보 인라인 입력 상태
const centerFormData = ref({
  m_sisul_name: '',
  m_user_name: '',
  m_biz_num: '',
  m_addr: '',
  m_addr_detail: '',
  m_sisul_call_num1: '',
  m_sisul_call_num2: '',
  m_sisul_call_num3: ''
});
const isSavingCenter = ref(false);
const isAddressLoading = ref(false);

// 폼 데이터
const formData = ref({
  type: '임금신고',
  newEmployees: [] as Employee[],
  resignedEmployees: [] as Employee[],
  memo: ''
});

// 요청 유형 목록 (추후 확장 가능)
const requestTypes = [
  { text: '임금신고', value: '임금신고' }
];

// 입사자로 선택 가능한 사원 (모든 사원 - 같은 달에 입사/퇴사 모두 가능)
const availableNewEmployees = computed(() => {
  return employees.value;
});

// 퇴사자로 선택 가능한 사원 (모든 사원 - 같은 달에 입사/퇴사 모두 가능)
const availableResignedEmployees = computed(() => {
  return employees.value;
});

// 주민등록번호 유효성 검증
const isValidBirthNumber = (birthNumber?: string) => {
  if (!birthNumber) return false;
  const cleaned = birthNumber.replace(/-/g, '');
  if (cleaned.length !== 13) return false;
  
  // 앞자리 6자리 (YYMMDD) 검증
  const front = cleaned.substring(0, 6);
  const month = parseInt(front.substring(2, 4), 10);
  const day = parseInt(front.substring(4, 6), 10);
  
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  
  // 뒷자리 첫 번째 숫자 (성별코드) 검증: 1~8
  const genderCode = parseInt(cleaned.charAt(6), 10);
  if (genderCode < 1 || genderCode > 8) return false;
  
  return true;
};

// 주민등록번호가 불완전한 사원 목록
const invalidBirthNumberEmployees = computed(() => {
  return employees.value.filter(emp => !isValidBirthNumber(emp.emp_birth_number));
});

// 유효한 입력이 완료된 주민등록번호 개수
const validBirthNumberCount = computed(() => {
  return Object.keys(birthNumberInputs.value).filter(empCode => isValidInput(empCode)).length;
});

// 임금신고 요청 가능 여부 (모든 사원의 주민등록번호 + 기관 필수정보)
const canSubmitRequest = computed(() => {
  return invalidBirthNumberEmployees.value.length === 0 && missingCenterFields.value.length === 0;
});

// 기관 필수 정보 검증
const centerInfo = computed(() => store.state.user);

const missingCenterFields = computed((): { field: string; label: string }[] => {
  const user = centerInfo.value;
  if (!user) return [{ field: 'none', label: '기관 정보 없음' }];
  
  const missing: { field: string; label: string }[] = [];
  
  if (!user.m_sisul_name?.trim()) {
    missing.push({ field: 'm_sisul_name', label: '기관명' });
  }
  if (!user.m_user_name?.trim()) {
    missing.push({ field: 'm_user_name', label: '대표자명' });
  }
  if (!user.m_biz_num?.trim()) {
    missing.push({ field: 'm_biz_num', label: '사업자등록번호' });
  }
  if (!user.m_addr?.trim()) {
    missing.push({ field: 'm_addr', label: '주소' });
  }
  if (!user.m_sisul_call_num1?.trim() || !user.m_sisul_call_num2?.trim() || !user.m_sisul_call_num3?.trim()) {
    missing.push({ field: 'm_sisul_call_num', label: '기관 전화번호' });
  }
  
  return missing;
});

// 주민등록번호 입력 상태 초기화
const initBirthNumberInputs = () => {
  const inputs: Record<string, { front: string; back: string }> = {};
  employees.value.forEach(emp => {
    if (!isValidBirthNumber(emp.emp_birth_number)) {
      // 앞자리, 뒷자리 모두 빈값으로 초기화 (생년월일에서 자동으로 채우지 않음)
      inputs[emp.emp_code] = { front: '', back: '' };
    }
  });
  birthNumberInputs.value = inputs;
};

// 생년월일에서 주민등록번호 앞자리 추출 (YYYYMMDD → YYMMDD)
const extractBirthFront = (birth: string): string => {
  if (!birth) return '';
  const digitsOnly = birth.replace(/[^\d]/g, '');
  if (digitsOnly.length >= 8) {
    return digitsOnly.substring(2, 8);
  }
  return '';
};

// 주민등록번호 앞자리 입력 핸들러
const onBirthFrontInput = (empCode: string, e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '');
  if (birthNumberInputs.value[empCode]) {
    birthNumberInputs.value[empCode].front = value;
  }
};

// 주민등록번호 뒷자리 입력 핸들러
const onBirthBackInput = (empCode: string, e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '');
  if (birthNumberInputs.value[empCode]) {
    birthNumberInputs.value[empCode].back = value;
  }
};

// 생년월일에서 앞자리 자동 채우기
const fillBirthFront = (emp: Employee) => {
  if (emp.emp_birth && birthNumberInputs.value[emp.emp_code]) {
    birthNumberInputs.value[emp.emp_code].front = extractBirthFront(emp.emp_birth);
  }
};

// 입력 유효성 검증 (앞6자리 + 뒤7자리 + 실제 유효한 값)
const isValidInput = (empCode: string) => {
  const input = birthNumberInputs.value[empCode];
  if (!input) return false;
  if (input.front.length !== 6 || input.back.length !== 7) return false;
  
  // 앞자리 (YYMMDD) 검증
  const month = parseInt(input.front.substring(2, 4), 10);
  const day = parseInt(input.front.substring(4, 6), 10);
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  
  // 뒷자리 첫 번째 숫자 (성별코드) 검증: 1~8
  const genderCode = parseInt(input.back.charAt(0), 10);
  if (genderCode < 1 || genderCode > 8) return false;
  
  return true;
};

// 유효성 검증 에러 메시지
const getValidationError = (empCode: string) => {
  const input = birthNumberInputs.value[empCode];
  if (!input) return '입력 필요';
  
  if (input.front.length !== 6) return `앞자리 ${input.front.length}/6자리`;
  if (input.back.length !== 7) return `뒷자리 ${input.back.length}/7자리`;
  
  const month = parseInt(input.front.substring(2, 4), 10);
  const day = parseInt(input.front.substring(4, 6), 10);
  if (month < 1 || month > 12) return `월(${month})이 잘못됨 (1~12)`;
  if (day < 1 || day > 31) return `일(${day})이 잘못됨 (1~31)`;
  
  const genderCode = parseInt(input.back.charAt(0), 10);
  if (genderCode < 1 || genderCode > 8) return `성별코드(${genderCode})가 잘못됨 (1~8)`;
  
  return '알 수 없는 오류';
};

// 주민등록번호 저장
const saveBirthNumber = async (emp: Employee) => {
  if (!isValidInput(emp.emp_code)) return;
  
  const input = birthNumberInputs.value[emp.emp_code];
  const fullBirthNumber = input.front + input.back;
  
  savingEmpCode.value = emp.emp_code;
  
  try {
    const response = await axios.post('/api/calc/employee', {
      emp_code: emp.emp_code,
      m_sisul_code: store.state.user?.m_sisul_code,
      emp_name: emp.emp_name,
      emp_birth: emp.emp_birth,
      emp_birth_number: fullBirthNumber,
      emp_job: emp.emp_job,
      emp_in_date: emp.emp_in_date,
      emp_out_date: emp.emp_out_date
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      // 로컬 사원 데이터 업데이트
      const empIndex = employees.value.findIndex(e => e.emp_code === emp.emp_code);
      if (empIndex >= 0) {
        employees.value[empIndex].emp_birth_number = fullBirthNumber;
      }
      
      // 입력 상태에서 제거
      delete birthNumberInputs.value[emp.emp_code];
      
      store.commit('showSnackbar', {
        text: `${emp.emp_name}님의 주민등록번호가 저장되었습니다.`,
        color: 'success'
      });
    } else {
      throw new Error(response.data.message || '저장 실패');
    }
  } catch (error: any) {
    console.error('주민등록번호 저장 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '주민등록번호 저장 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    savingEmpCode.value = null;
  }
};

// 주민등록번호 일괄 저장
const saveAllBirthNumbers = async () => {
  const validEmployees = invalidBirthNumberEmployees.value.filter(emp => isValidInput(emp.emp_code));
  
  if (validEmployees.length === 0) {
    store.commit('showSnackbar', {
      text: '저장할 유효한 주민등록번호가 없습니다.',
      color: 'warning'
    });
    return;
  }
  
  isSavingAllBirthNumbers.value = true;
  let successCount = 0;
  let failCount = 0;
  
  try {
    for (const emp of validEmployees) {
      const input = birthNumberInputs.value[emp.emp_code];
      const fullBirthNumber = input.front + input.back;
      
      try {
        const response = await axios.post('/api/calc/employee', {
          emp_code: emp.emp_code,
          m_sisul_code: store.state.user?.m_sisul_code,
          emp_name: emp.emp_name,
          emp_birth: emp.emp_birth,
          emp_birth_number: fullBirthNumber,
          emp_job: emp.emp_job,
          emp_in_date: emp.emp_in_date,
          emp_out_date: emp.emp_out_date
        }, {
          withCredentials: true
        });
        
        if (response.data.success) {
          // 로컬 사원 데이터 업데이트
          const empIndex = employees.value.findIndex(e => e.emp_code === emp.emp_code);
          if (empIndex >= 0) {
            employees.value[empIndex].emp_birth_number = fullBirthNumber;
          }
          
          // 입력 상태에서 제거
          delete birthNumberInputs.value[emp.emp_code];
          successCount++;
        } else {
          failCount++;
        }
      } catch {
        failCount++;
      }
    }
    
    if (successCount > 0) {
      store.commit('showSnackbar', {
        text: `${successCount}명의 주민등록번호가 저장되었습니다.${failCount > 0 ? ` (${failCount}명 실패)` : ''}`,
        color: failCount > 0 ? 'warning' : 'success'
      });
    } else {
      store.commit('showSnackbar', {
        text: '주민등록번호 저장에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('주민등록번호 일괄 저장 오류:', error);
    store.commit('showSnackbar', {
      text: '주민등록번호 일괄 저장 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isSavingAllBirthNumbers.value = false;
  }
};

// 저장된 입사자/퇴사자 파싱
const parsedNewEmployees = computed(() => {
  if (!currentRequest.value?.wtr_new_employees) return [];
  try {
    return JSON.parse(currentRequest.value.wtr_new_employees);
  } catch {
    return [];
  }
});

const parsedResignedEmployees = computed(() => {
  if (!currentRequest.value?.wtr_resigned_employees) return [];
  try {
    return JSON.parse(currentRequest.value.wtr_resigned_employees);
  } catch {
    return [];
  }
});

// 선택 상태 확인
const isSelectedNew = (empCode: string) => {
  return formData.value.newEmployees.some(e => e.emp_code === empCode);
};

const isSelectedResigned = (empCode: string) => {
  return formData.value.resignedEmployees.some(e => e.emp_code === empCode);
};

// 입사자 토글
const toggleNewEmployee = (emp: Employee) => {
  const idx = formData.value.newEmployees.findIndex(e => e.emp_code === emp.emp_code);
  if (idx >= 0) {
    formData.value.newEmployees.splice(idx, 1);
  } else {
    formData.value.newEmployees.push(emp);
  }
};

// 퇴사자 토글
const toggleResignedEmployee = (emp: Employee) => {
  const idx = formData.value.resignedEmployees.findIndex(e => e.emp_code === emp.emp_code);
  if (idx >= 0) {
    formData.value.resignedEmployees.splice(idx, 1);
  } else {
    formData.value.resignedEmployees.push(emp);
  }
};

// 상태별 스타일
const getStatusClass = (status: string) => {
  switch (status) {
    case '요청': return 'pending';
    case '승인': return 'approved';
    case '미승인': return 'rejected';
    case '취소': return 'cancelled';
    default: return '';
  }
};

const getStatusColor = (status: string) => {
  switch (status) {
    case '요청': return '#3b82f6';
    case '승인': return '#10b981';
    case '미승인': return '#ef4444';
    case '취소': return '#6b7280';
    default: return '#6b7280';
  }
};

const getStatusIcon = (status: string) => {
  switch (status) {
    case '요청': return 'mdi-clock-outline';
    case '승인': return 'mdi-check-circle';
    case '미승인': return 'mdi-close-circle';
    case '취소': return 'mdi-cancel';
    default: return 'mdi-help-circle';
  }
};

const getStatusTitle = (status: string) => {
  switch (status) {
    case '요청': return '요청 대기중';
    case '승인': return '승인 완료';
    case '미승인': return '미승인';
    case '취소': return '요청 취소됨';
    default: return status;
  }
};

// 날짜 포맷
const formatDate = (date?: string) => {
  if (!date) return '-';
  if (date.includes('-')) return date;
  if (date.length === 8) {
    return `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`;
  }
  return date;
};

// 생년월일 포맷 (예: 19900101 → 90.01.01)
const formatBirth = (birth?: string) => {
  if (!birth) return '';
  const cleaned = birth.replace(/-/g, '');
  if (cleaned.length >= 8) {
    return `${cleaned.substring(2, 4)}.${cleaned.substring(4, 6)}.${cleaned.substring(6, 8)}`;
  }
  return birth;
};

const formatDateTime = (datetime?: string) => {
  if (!datetime) return '-';
  const d = new Date(datetime);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

// 입사자/퇴사자 자동 선택 (해당 월에 입사/퇴사한 사원)
const autoSelectEmployees = () => {
  if (!props.yearMonth) return;
  
  const targetYm = props.yearMonth; // YYYYMM 형식
  
  // 폼 데이터 초기화
  formData.value.newEmployees = [];
  formData.value.resignedEmployees = [];
  
  employees.value.forEach(emp => {
    // 입사일 체크 (YYYYMMDD 또는 YYYY-MM-DD 형식)
    if (emp.emp_in_date) {
      const inDateYm = emp.emp_in_date.replace(/-/g, '').substring(0, 6);
      if (inDateYm === targetYm) {
        formData.value.newEmployees.push(emp);
      }
    }
    
    // 퇴사일 체크 (YYYYMMDD 또는 YYYY-MM-DD 형식)
    // 같은 달에 입사와 퇴사를 함께 하는 경우도 있으므로 독립적으로 체크
    if (emp.emp_out_date) {
      const outDateYm = emp.emp_out_date.replace(/-/g, '').substring(0, 6);
      if (outDateYm === targetYm) {
        formData.value.resignedEmployees.push(emp);
      }
    }
  });
};

// 데이터 로드
const loadData = async () => {
  const user = store.state.user;
  if (!user?.m_sisul_code || !props.yearMonth) return;

  isLoading.value = true;
  try {
    // 기존 요청 조회
    const requestRes = await axios.get('/api/wage-process/tax-request', {
      params: {
        sisulCode: user.m_sisul_code,
        yearMonth: props.yearMonth
      }
    });

    if (requestRes.data.success && requestRes.data.data) {
      currentRequest.value = requestRes.data.data;
    } else {
      currentRequest.value = null;
    }

    // 사원 목록 조회
    const empRes = await axios.get(`/api/emp/facility/${user.m_sisul_code}`);
    if (empRes.data.success) {
      employees.value = empRes.data.data || [];
      // 주민등록번호 입력 상태 초기화
      initBirthNumberInputs();
      // 기관 정보 폼 초기화
      initCenterFormData();
      // 입사자/퇴사자 자동 선택 (기존 요청이 없는 경우에만)
      if (!currentRequest.value) {
        autoSelectEmployees();
      }
    }
  } catch (error) {
    console.error('데이터 로드 오류:', error);
  } finally {
    isLoading.value = false;
  }
};

// 요청 제출
const handleSubmit = async () => {
  const user = store.state.user;
  if (!user?.m_sisul_code || !props.yearMonth) return;

  isSubmitting.value = true;
  try {
    const response = await axios.post('/api/wage-process/tax-request', {
      sisulCode: user.m_sisul_code,
      yearMonth: props.yearMonth,
      type: formData.value.type,
      newEmployees: formData.value.newEmployees.map(e => ({ emp_code: e.emp_code, emp_name: e.emp_name })),
      resignedEmployees: formData.value.resignedEmployees.map(e => ({ emp_code: e.emp_code, emp_name: e.emp_name })),
      memo: formData.value.memo,
      requestedBy: user.m_id
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: '임금신고 요청이 완료되었습니다.',
        color: 'success'
      });
      emit('request-submitted');
      await loadData();
    } else {
      throw new Error(response.data.message || '요청 실패');
    }
  } catch (error: any) {
    console.error('요청 제출 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '요청 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isSubmitting.value = false;
  }
};

// 요청 취소
const handleCancelRequest = async () => {
  const user = store.state.user;
  if (!user?.m_sisul_code || !currentRequest.value) return;

  isCancelling.value = true;
  try {
    const response = await axios.post('/api/wage-process/tax-request/cancel', {
      sisulCode: user.m_sisul_code,
      yearMonth: props.yearMonth,
      cancelReason: cancelReason.value,
      cancelledBy: user.m_id
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: '요청이 취소되었습니다.',
        color: 'success'
      });
      showCancelDialog.value = false;
      cancelReason.value = '';
      emit('request-cancelled');
      await loadData();
    } else {
      throw new Error(response.data.message || '취소 실패');
    }
  } catch (error: any) {
    console.error('요청 취소 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '취소 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isCancelling.value = false;
  }
};

// 닫기
const handleClose = () => {
  dialogVisible.value = false;
  // 폼 초기화
  formData.value = {
    type: '임금신고',
    newEmployees: [],
    resignedEmployees: [],
    memo: ''
  };
  cancelReason.value = '';
};

// 기관 정보 폼 초기화
const initCenterFormData = () => {
  const user = store.state.user;
  if (user) {
    centerFormData.value = {
      m_sisul_name: user.m_sisul_name || '',
      m_user_name: user.m_user_name || '',
      m_biz_num: user.m_biz_num || '',
      m_addr: user.m_addr || '',
      m_addr_detail: user.m_addr_detail || '',
      m_sisul_call_num1: user.m_sisul_call_num1 || '',
      m_sisul_call_num2: user.m_sisul_call_num2 || '',
      m_sisul_call_num3: user.m_sisul_call_num3 || ''
    };
  }
};

// Daum 우편번호 검색 스크립트 로드
let daumScriptLoading: Promise<void> | null = null;

const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

// 주소 검색 팝업 열기
const openAddressSearch = async () => {
  isAddressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode not loaded');
    
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        centerFormData.value.m_addr = selected || '';
        isAddressLoading.value = false;
      },
      onclose: () => {
        isAddressLoading.value = false;
      }
    });
    postcode.open();
  } catch (e) {
    console.error('주소 검색 오류:', e);
    isAddressLoading.value = false;
    store.commit('showSnackbar', {
      text: '주소 검색을 불러올 수 없습니다.',
      color: 'error'
    });
  }
};

// 기관 정보 저장
const saveCenterInfo = async () => {
  isSavingCenter.value = true;
  
  try {
    const response = await axios.put('/api/auth/account', {
      ...store.state.user,
      ...centerFormData.value
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      // 스토어의 user 정보 업데이트
      store.commit('setUser', {
        ...store.state.user,
        ...centerFormData.value
      });
      
      store.commit('showSnackbar', {
        text: '기관 정보가 저장되었습니다.',
        color: 'success'
      });
    } else {
      throw new Error(response.data.message || '저장 실패');
    }
  } catch (error: any) {
    console.error('기관 정보 저장 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '기관 정보 저장 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isSavingCenter.value = false;
  }
};

// 사업자등록번호 포맷 (000-00-00000)
const onBizNumInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const digits = target.value.replace(/[^\d]/g, '').slice(0, 10);
  
  let formatted = digits;
  if (digits.length > 3 && digits.length <= 5) {
    formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
  } else if (digits.length > 5) {
    formatted = `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
  }
  
  centerFormData.value.m_biz_num = formatted;
};

// 다이얼로그 열릴 때 데이터 로드
watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    loadData();
  }
});

// props.yearMonth 변경 시 데이터 재로드
watch(() => props.yearMonth, () => {
  if (props.modelValue) {
    loadData();
  }
});

// 현재 요청 상태 expose (부모 컴포넌트에서 접근 가능)
__expose({
  currentRequest,
  loadData
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "700px",
    height: "90vh"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "wage-tax-req-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "#1e3a8a"
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("mdi-file-document-edit", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[19] || (_cache[19] = _createElementVNode("h2", null, "임금신고 요청", -1)),
              _createElementVNode("p", null, _toDisplayString(__props.yearMonth ? `${__props.yearMonth.substring(0, 4)}년 ${__props.yearMonth.substring(4, 6)}월` : '') + " 임금신고", 1)
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: handleClose,
              disabled: isSubmitting.value
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_4)
          ]),
          (currentRequest.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["request-status-card", getStatusClass(currentRequest.value.wtr_status)])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_icon, {
                      size: "32",
                      color: getStatusColor(currentRequest.value.wtr_status)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStatusIcon(currentRequest.value.wtr_status)), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", null, _toDisplayString(getStatusTitle(currentRequest.value.wtr_status)), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(currentRequest.value.wtr_status === '요청' ? '요청일시' : 
                 currentRequest.value.wtr_status === '취소' ? '취소일시' : '처리일시') + ": " + _toDisplayString(formatDateTime(currentRequest.value.wtr_status === '요청' ? currentRequest.value.wtr_requested_at : 
                               currentRequest.value.wtr_status === '취소' ? currentRequest.value.wtr_cancelled_at : 
                               currentRequest.value.wtr_processed_at)), 1)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_9, [
                  _cache[25] || (_cache[25] = _createElementVNode("h4", null, "요청 내용", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "요청 유형", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(currentRequest.value.wtr_type), 1)
                  ]),
                  (parsedNewEmployees.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "입사자", -1)),
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedNewEmployees.value, (emp) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: emp.emp_code,
                              class: "emp-chip new"
                            }, _toDisplayString(emp.emp_name), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (parsedResignedEmployees.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "퇴사자", -1)),
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedResignedEmployees.value, (emp) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: emp.emp_code,
                              class: "emp-chip resigned"
                            }, _toDisplayString(emp.emp_name), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (currentRequest.value.wtr_request_memo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "요청 메모", -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(currentRequest.value.wtr_request_memo), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (currentRequest.value.wtr_status === '승인' || currentRequest.value.wtr_status === '미승인')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _cache[26] || (_cache[26] = _createElementVNode("h4", null, "관리자 응답", -1)),
                      (currentRequest.value.wtr_result_memo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(currentRequest.value.wtr_result_memo), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, "메모 없음"))
                    ]))
                  : _createCommentVNode("", true),
                (currentRequest.value.wtr_status === '취소' && currentRequest.value.wtr_cancel_reason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[27] || (_cache[27] = _createElementVNode("h4", null, "취소 사유", -1)),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(currentRequest.value.wtr_cancel_reason), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                (missingCenterFields.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_v_icon, {
                          size: "24",
                          color: "#f59e0b"
                        }, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("mdi-domain", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", null, "기관 필수 정보 미입력 (" + _toDisplayString(missingCenterFields.value.length) + "개)", 1)
                      ]),
                      _cache[41] || (_cache[41] = _createElementVNode("p", { class: "warning-desc" }, "아래에서 기관 정보를 직접 입력하여 저장할 수 있습니다.", -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["center-form-item", { 'has-error': !centerFormData.value.m_sisul_name }])
                        }, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", null, [
                            _createTextVNode("기관명 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((centerFormData.value.m_sisul_name) = $event)),
                            type: "text",
                            placeholder: "기관명을 입력하세요",
                            maxlength: "45"
                          }, null, 512), [
                            [_vModelText, centerFormData.value.m_sisul_name]
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["center-form-item", { 'has-error': !centerFormData.value.m_user_name }])
                        }, [
                          _cache[30] || (_cache[30] = _createElementVNode("label", null, [
                            _createTextVNode("대표자명 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((centerFormData.value.m_user_name) = $event)),
                            type: "text",
                            placeholder: "대표자명을 입력하세요",
                            maxlength: "45"
                          }, null, 512), [
                            [_vModelText, centerFormData.value.m_user_name]
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["center-form-item", { 'has-error': !centerFormData.value.m_biz_num }])
                        }, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", null, [
                            _createTextVNode("사업자등록번호 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((centerFormData.value.m_biz_num) = $event)),
                            type: "text",
                            placeholder: "000-00-00000",
                            maxlength: "12",
                            onInput: onBizNumInput
                          }, null, 544), [
                            [_vModelText, centerFormData.value.m_biz_num]
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["center-form-item full-width", { 'has-error': !centerFormData.value.m_sisul_call_num1 || !centerFormData.value.m_sisul_call_num2 || !centerFormData.value.m_sisul_call_num3 }])
                        }, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", null, [
                            _createTextVNode("기관 전화번호 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((centerFormData.value.m_sisul_call_num1) = $event)),
                              type: "text",
                              placeholder: "02",
                              maxlength: "4",
                              onInput: _cache[4] || (_cache[4] = (e) => (centerFormData.value.m_sisul_call_num1 = e.target.value.replace(/[^\d]/g, '').slice(0, 4)))
                            }, null, 544), [
                              [_vModelText, centerFormData.value.m_sisul_call_num1]
                            ]),
                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((centerFormData.value.m_sisul_call_num2) = $event)),
                              type: "text",
                              placeholder: "1234",
                              maxlength: "4",
                              onInput: _cache[6] || (_cache[6] = (e) => (centerFormData.value.m_sisul_call_num2 = e.target.value.replace(/[^\d]/g, '').slice(0, 4)))
                            }, null, 544), [
                              [_vModelText, centerFormData.value.m_sisul_call_num2]
                            ]),
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "phone-separator" }, "-", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((centerFormData.value.m_sisul_call_num3) = $event)),
                              type: "text",
                              placeholder: "5678",
                              maxlength: "4",
                              onInput: _cache[8] || (_cache[8] = (e) => (centerFormData.value.m_sisul_call_num3 = e.target.value.replace(/[^\d]/g, '').slice(0, 4)))
                            }, null, 544), [
                              [_vModelText, centerFormData.value.m_sisul_call_num3]
                            ])
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["center-form-item full-width", { 'has-error': !centerFormData.value.m_addr }])
                        }, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", null, [
                            _createTextVNode("주소 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((centerFormData.value.m_addr) = $event)),
                              type: "text",
                              placeholder: "주소 검색 버튼을 클릭하세요",
                              maxlength: "100",
                              readonly: "",
                              onClick: openAddressSearch
                            }, null, 512), [
                              [_vModelText, centerFormData.value.m_addr]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "address-search-btn",
                              onClick: openAddressSearch,
                              disabled: isAddressLoading.value
                            }, [
                              (isAddressLoading.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    size: "14",
                                    width: "2",
                                    color: "white"
                                  }))
                                : (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    size: "16"
                                  }, {
                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                      _createTextVNode("mdi-magnify", -1)
                                    ]))]),
                                    _: 1
                                  })),
                              _cache[36] || (_cache[36] = _createTextVNode(" 검색 ", -1))
                            ], 8, _hoisted_29)
                          ])
                        ], 2),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", null, "상세주소", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((centerFormData.value.m_addr_detail) = $event)),
                            type: "text",
                            placeholder: "상세주소를 입력하세요 (동/호수 등)",
                            maxlength: "100"
                          }, null, 512), [
                            [_vModelText, centerFormData.value.m_addr_detail]
                          ])
                        ])
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "save-center-btn",
                        onClick: saveCenterInfo,
                        disabled: isSavingCenter.value || missingCenterFields.value.length > 0 && !centerFormData.value.m_sisul_name && !centerFormData.value.m_user_name
                      }, [
                        (isSavingCenter.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              size: "16",
                              width: "2",
                              color: "white",
                              class: "mr-1"
                            }))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              size: "16",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                _createTextVNode("mdi-content-save", -1)
                              ]))]),
                              _: 1
                            })),
                        _cache[40] || (_cache[40] = _createTextVNode(" 기관 정보 저장 ", -1))
                      ], 8, _hoisted_31)
                    ]))
                  : _createCommentVNode("", true),
                (invalidBirthNumberEmployees.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_v_icon, {
                          size: "24",
                          color: "#ef4444"
                        }, {
                          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                            _createTextVNode("mdi-alert-circle", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", null, "주민등록번호 미등록 사원 (" + _toDisplayString(invalidBirthNumberEmployees.value.length) + "명)", 1)
                      ]),
                      _cache[48] || (_cache[48] = _createElementVNode("p", { class: "warning-desc" }, "아래에서 주민등록번호를 직접 입력하여 등록할 수 있습니다.", -1)),
                      _cache[49] || (_cache[49] = _createElementVNode("p", { class: "warning-desc" }, "생년월일과 주민등록번호 앞자리가 다른 사원이 있을 수 있으니 주의해주세요.", -1)),
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invalidBirthNumberEmployees.value, (emp) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: emp.emp_code,
                            class: "birth-number-edit-item"
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                color: "#ef4444"
                              }, {
                                default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                  _createTextVNode("mdi-account-alert", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_36, _toDisplayString(emp.emp_name), 1),
                              (emp.emp_birth)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "(" + _toDisplayString(formatBirth(emp.emp_birth)) + ")", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((birthNumberInputs.value[emp.emp_code].front) = $event),
                                type: "text",
                                class: "birth-input front",
                                maxlength: "6",
                                placeholder: "앞 6자리",
                                onInput: ($event: any) => (onBirthFrontInput(emp.emp_code, $event))
                              }, null, 40, _hoisted_39), [
                                [_vModelText, birthNumberInputs.value[emp.emp_code].front]
                              ]),
                              _cache[46] || (_cache[46] = _createElementVNode("span", { class: "birth-separator" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((birthNumberInputs.value[emp.emp_code].back) = $event),
                                type: "text",
                                class: "birth-input back",
                                maxlength: "7",
                                placeholder: "뒤 7자리",
                                onInput: ($event: any) => (onBirthBackInput(emp.emp_code, $event))
                              }, null, 40, _hoisted_40), [
                                [_vModelText, birthNumberInputs.value[emp.emp_code].back]
                              ]),
                              (emp.emp_birth && !birthNumberInputs.value[emp.emp_code].front)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "fill-btn",
                                    onClick: ($event: any) => (fillBirthFront(emp)),
                                    title: "생년월일에서 앞자리 채우기"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                        _createTextVNode("mdi-auto-fix", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_41))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "button",
                                class: "save-btn",
                                disabled: !isValidInput(emp.emp_code) || savingEmpCode.value === emp.emp_code,
                                onClick: ($event: any) => (saveBirthNumber(emp))
                              }, [
                                (savingEmpCode.value === emp.emp_code)
                                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                      key: 0,
                                      indeterminate: "",
                                      size: "14",
                                      width: "2",
                                      color: "white"
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      size: "16"
                                    }, {
                                      default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                        _createTextVNode("mdi-check", -1)
                                      ]))]),
                                      _: 1
                                    }))
                              ], 8, _hoisted_42)
                            ]),
                            (birthNumberInputs.value[emp.emp_code].front || birthNumberInputs.value[emp.emp_code].back)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createTextVNode(_toDisplayString(birthNumberInputs.value[emp.emp_code].front || '______') + "-" + _toDisplayString(birthNumberInputs.value[emp.emp_code].back || '_______') + " ", 1),
                                  (isValidInput(emp.emp_code))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, "✓ 유효"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(getValidationError(emp.emp_code)), 1))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "save-all-birth-btn",
                        onClick: saveAllBirthNumbers,
                        disabled: isSavingAllBirthNumbers.value || validBirthNumberCount.value === 0
                      }, [
                        (isSavingAllBirthNumbers.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              size: "16",
                              width: "2",
                              color: "white",
                              class: "mr-1"
                            }))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              size: "16",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                _createTextVNode("mdi-content-save-all", -1)
                              ]))]),
                              _: 1
                            })),
                        _createTextVNode(" 주민등록번호 일괄 저장 (" + _toDisplayString(validBirthNumberCount.value) + "명) ", 1)
                      ], 8, _hoisted_46)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_47, [
                  _cache[50] || (_cache[50] = _createElementVNode("label", { class: "form-label" }, "요청 유형", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: formData.value.type,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.type) = $event)),
                    items: requestTypes,
                    "item-title": "text",
                    "item-value": "value",
                    variant: "outlined",
                    density: "comfortable",
                    "hide-details": "",
                    class: "type-select"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("label", _hoisted_50, [
                      _cache[51] || (_cache[51] = _createTextVNode("입사자 선택 ", -1)),
                      (formData.value.newEmployees.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, "(" + _toDisplayString(formData.value.newEmployees.length) + "명 선택)", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "section-hint" }, "입사자로 등록할 직원을 선택하세요", -1))
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableNewEmployees.value, (emp) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'new-' + emp.emp_code,
                        class: _normalizeClass(["employee-card selectable", { 'selected': isSelectedNew(emp.emp_code) }]),
                        onClick: ($event: any) => (toggleNewEmployee(emp))
                      }, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "white"
                          }, {
                            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                              _createTextVNode("mdi-account-plus", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("span", _hoisted_56, [
                            _createTextVNode(_toDisplayString(emp.emp_name) + " ", 1),
                            (emp.emp_birth)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "(" + _toDisplayString(formatBirth(emp.emp_birth)) + ")", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_58, "입사: " + _toDisplayString(formatDate(emp.emp_in_date)), 1)
                        ]),
                        (isSelectedNew(emp.emp_code))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                color: "#10b981"
                              }, {
                                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                  _createTextVNode("mdi-check-circle", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_53))
                    }), 128)),
                    (availableNewEmployees.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, " 선택 가능한 사원이 없습니다 "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, [
                      _cache[55] || (_cache[55] = _createTextVNode("퇴사자 선택 ", -1)),
                      (formData.value.resignedEmployees.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, "(" + _toDisplayString(formData.value.resignedEmployees.length) + "명 선택)", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[56] || (_cache[56] = _createElementVNode("span", { class: "section-hint" }, "퇴사자로 등록할 직원을 선택하세요", -1))
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableResignedEmployees.value, (emp) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'resigned-' + emp.emp_code,
                        class: _normalizeClass(["employee-card selectable", { 'selected': isSelectedResigned(emp.emp_code) }]),
                        onClick: ($event: any) => (toggleResignedEmployee(emp))
                      }, [
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "white"
                          }, {
                            default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                              _createTextVNode("mdi-account-minus", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("span", _hoisted_69, [
                            _createTextVNode(_toDisplayString(emp.emp_name) + " ", 1),
                            (emp.emp_birth)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, "(" + _toDisplayString(formatBirth(emp.emp_birth)) + ")", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_71, _toDisplayString(emp.emp_out_date ? '퇴사: ' + formatDate(emp.emp_out_date) : '재직중'), 1)
                        ]),
                        (isSelectedResigned(emp.emp_code))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                color: "#10b981"
                              }, {
                                default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                  _createTextVNode("mdi-check-circle", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_66))
                    }), 128)),
                    (availableResignedEmployees.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, " 선택 가능한 사원이 없습니다 "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _cache[59] || (_cache[59] = _createElementVNode("label", { class: "form-label" }, "요청 메모", -1)),
                  _createVNode(_component_v_textarea, {
                    modelValue: formData.value.memo,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.memo) = $event)),
                    variant: "outlined",
                    placeholder: "관리자에게 전달할 메모를 입력하세요 (선택사항)",
                    rows: "3",
                    "hide-details": "",
                    class: "memo-textarea"
                  }, null, 8, ["modelValue"])
                ])
              ])),
          _createElementVNode("div", _hoisted_75, [
            (currentRequest.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (currentRequest.value.wtr_status === '요청')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn-cancel-request",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (showCancelDialog.value = true)),
                        disabled: isSubmitting.value
                      }, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                            _createTextVNode("mdi-close-circle", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[61] || (_cache[61] = _createTextVNode(" 요청 취소 ", -1))
                      ], 8, _hoisted_76))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn-close",
                    onClick: handleClose
                  }, " 닫기 ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    class: "btn-cancel",
                    onClick: handleClose,
                    disabled: isSubmitting.value
                  }, " 취소 ", 8, _hoisted_77),
                  _createElementVNode("button", {
                    class: "btn-submit",
                    onClick: handleSubmit,
                    disabled: isSubmitting.value || !canSubmitRequest.value
                  }, [
                    (isSubmitting.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "18",
                          width: "2",
                          color: "white",
                          class: "mr-2"
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                            _createTextVNode("mdi-send", -1)
                          ]))]),
                          _: 1
                        })),
                    _createTextVNode(" " + _toDisplayString(canSubmitRequest.value ? '요청하기' : '필수정보 누락'), 1)
                  ], 8, _hoisted_78)
                ], 64))
          ]),
          _createVNode(_component_v_dialog, {
            modelValue: showCancelDialog.value,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showCancelDialog).value = $event)),
            "max-width": "400px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "cancel-confirm-dialog" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      color: "#f59e0b"
                    }, {
                      default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                        _createTextVNode("mdi-alert-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[64] || (_cache[64] = _createElementVNode("h3", null, "요청 취소", -1))
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _cache[65] || (_cache[65] = _createElementVNode("p", null, "임금신고 요청을 취소하시겠습니까?", -1)),
                    _createVNode(_component_v_textarea, {
                      modelValue: cancelReason.value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((cancelReason).value = $event)),
                      variant: "outlined",
                      placeholder: "취소 사유를 입력하세요 (선택사항)",
                      rows: "2",
                      "hide-details": "",
                      class: "cancel-reason-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("button", {
                      class: "btn-dialog-cancel",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (showCancelDialog.value = false)),
                      disabled: isCancelling.value
                    }, "취소", 8, _hoisted_82),
                    _createElementVNode("button", {
                      class: "btn-dialog-confirm warning",
                      onClick: handleCancelRequest,
                      disabled: isCancelling.value
                    }, [
                      (isCancelling.value)
                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                            key: 0,
                            indeterminate: "",
                            size: "16",
                            width: "2",
                            color: "white",
                            class: "mr-1"
                          }))
                        : _createCommentVNode("", true),
                      _cache[66] || (_cache[66] = _createTextVNode(" 요청 취소 ", -1))
                    ], 8, _hoisted_83)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})